module.exports = "/_next/static/images/kobikicho_in-364f98014e6eda432c933587e2100627.jpg";